import { API_NEW } from "src/API";
import { GarAddressType, GarHintType } from "./Types";

export default class GarAPI extends API_NEW {

	/** Запрос за подсказками */
	static getHints = ( text: string, controller: AbortController ) => this.onRequest<GarHintType[]>({
		url: (window.host + "/Nvx.ReDoc.DynamicFormsGarControl.Web.Controller.GarController/GetHints?name=" + text),
		withCredentials: true,
		signal: controller.signal
	});

	/** Запрос за адресом по ИД адреса */
	static getAddress = ( id: string, controller: AbortController ) => this.onRequest<GarAddressType>({
		url: window.host + "/Nvx.ReDoc.DynamicFormsGarControl.Web.Controller.GarController/GetAddressById/" + id,
		withCredentials: true,
		signal: controller.signal
	});

};